export const emailAccounts = {
  rows: [
    {
      address: 'user1',
      box_suspensions: { login: true },
      type: 'system',
      disk_used_mib: 1024,
      disk_limit_mib: 2048,
      disk_used_percent: 50,
    },
    {
      address: 'user2@example.com',
      box_suspensions: {
        incoming: true,
        login: null,
        outgoing: null,
        outgoing_hold: null,
      },
      type: 'box',
      disk_used_mib: 2048,
      disk_limit_mib: 4096,
      disk_used_percent: 75,
    },
    {
      address: 'testmail@aze.lcb.mybluehost.me',
      type: 'box',
      files: 1,
      disk_used_mib: 3419.0,
      disk_limit_mib: 10240,
      disk_used_percent: 33.4,
      box_suspensions: {
        incoming: true,
        login: true,
        outgoing: true,
        outgoing_hold: true,
      },
    },
    {
      address: 'azelcbmy',
      type: 'system',
      files: 241,
      disk_used_mib: 10240,
      disk_limit_mib: 10240,
      disk_used_percent: 100.0,
    },
    {
      address: 'test@aze.lcb.mybluehost.me',
      type: 'box',
      files: 1,
      disk_used_mib: 603.0,
      disk_limit_mib: 600.0,
      disk_used_percent: 100.5,
    },
    {
      address: 'xyz@aze.lcb.mybluehost.me',
      type: 'box',
      files: 1,
      disk_used_mib: 320.0,
      disk_limit_mib: 400.0,
      disk_used_percent: 80.0,
    },
    {
      address: 'hello@xyz.com',
      type: 'box',
      files: 242,
      disk_used_mib: 2375.0,
      disk_limit_mib: 4000.0,
      disk_used_percent: 59.4,
    },
  ],
};
